
// @ts-nocheck

import {
  TechnicianData,
  TechnicianTreeMapData,
} from "../components/charts/tim-toa/types";

export function formatDataChartCurrentEmployeesWorking(
  data: TechnicianData
): TechnicianTreeMapData[] {
  return [
    {
      name: "Técnico com atividades",
      value: data.total_tecnicos_com_trabalho,
      technicians: data.tecnicos_com_trabalho,
    },
    {
      name: "Técnico sem atividade",
      value: data.total_tecnicos_sem_trabalho,
      technicians: data.tecnicos_sem_trabalho,
    },
  ];
}
